import { jsx as _jsx } from "react/jsx-runtime";
const variantStyles = {
    default: { background: 'var(--color-text)', color: 'var(--color-bg)' },
    secondary: { background: 'var(--color-surface-raised)', color: 'var(--color-text)' },
    ghost: { background: 'transparent', color: 'var(--color-text-muted)' },
    destructive: { background: 'var(--color-danger)', color: 'var(--color-text-inverse)' },
};
const sizeStyles = {
    sm: { height: '32px', padding: '0 12px' },
    default: { height: '40px', padding: '0 16px' },
    lg: { height: '48px', padding: '0 24px', fontSize: '1rem' },
};
export function Button({ variant = 'default', size = 'default', style, disabled, onMouseEnter, onMouseLeave, ...props }) {
    const handleMouseEnter = (e) => {
        if (!disabled && variant === 'default') {
            e.currentTarget.style.boxShadow = '0 0 12px var(--color-accent-glow)';
        }
        onMouseEnter?.(e);
    };
    const handleMouseLeave = (e) => {
        if (variant === 'default') {
            e.currentTarget.style.boxShadow = '';
        }
        onMouseLeave?.(e);
    };
    return (_jsx("button", { disabled: disabled, style: {
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            gap: '8px', whiteSpace: 'nowrap',
            fontFamily: 'var(--font-family-body)',
            fontSize: '0.875rem', fontWeight: 700,
            borderRadius: 'var(--radius-md)',
            border: 'none', cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.5 : 1,
            transition: 'color 200ms, background-color 200ms, box-shadow 200ms, opacity 200ms',
            outline: 'none',
            ...variantStyles[variant],
            ...sizeStyles[size],
            ...style,
        }, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, ...props }));
}
